// layer
import EmailOptInLayer from '../ui/layer/EmailOptInLayer';
import SurgeSaleDealLayer from '../ui/layer/SurgeSaleDealLayer';
import CartFullLayer from '../ui/layer/CartFullLayer';

/**
 * @export
 * @class InnerCartCountValidator
 * 이너카트 추가 등 액션 관리
 *  - 옵션 단위 딜(opt_deal_srl) 일 경우 대상 옵션에 따라 데이터 자동완성
 *  - 사용자가 InnerCart에 담고자하는 옵션 수량 검증 및 confirm/reject
 */
export default class InnerCartManager {
  constructor() {
    const { optionInfo, htStaticData } = TMON.oApp.htStorage;
    if (!optionInfo || !optionInfo.options || !optionInfo.options.length) return;

    const { bOptionDeal, optionDealSrl } = htStaticData;
    this.bOptionDeal = bOptionDeal && optionDealSrl;
    this.optionDealSrl = optionDealSrl;
    this.bOnlyOption = optionInfo.isOnlyOption;

    if (this.bOptionDeal) { // 옵션 단위 딜 - 자동완성 일 때
      TMON.oApp.oPurchaseSelector.updateAllOptionUI();
    } else if (this.bOnlyOption) { // 단일 옵션일 때 요청
      this.getSingleList();
    }

    this.bEnablePuchaseAreaButton = true;

    if (TMON.oApp.htStorage.purchaseOption) {
      this.bPendingOptionList = true;
      this.onChangePurchaseOption();
    }
  }

  getLastDepthList() {
    const { selectedList } = TMON.oApp.htStorage.optionInfo;
    const lastDepthList = selectedList[selectedList.length - 2].item.childNodes;
    TMON.oApp.oApi.fetchApi('optionList', {
      aSelectedChildOptionDealSrls: lastDepthList.map(opton => opton.dealNo),
    });
  }

  getSingleList() {
    const { onlyOptionSrl } = TMON.oApp.htStorage.optionInfo;
    TMON.oApp.oApi.fetchApi('optionList', {
      aSelectedChildOptionDealSrls: [ onlyOptionSrl ],
    });
  }


  update(sStorageKey) {
    switch (sStorageKey) {
      case 'purchaseOption':
        this.onChangePurchaseOption();
        break;
      case 'buyNow':
        this.onBuyNow();
        break;
      case 'buyGift':
        this.onBuyGift();
        break;
      case 'optionList':
        this.onOptionList();
        break;
      case 'validateAddToInnerCart':
        this.validateAddToInnerCart();
        break;
      case 'validateAddToCart':
        this.validateAddToCart();
        break;
      case 'validateBuyNow':
        this.validateBuyNow();
        break;
      case 'validateBuyGift':
        this.validateBuyGift();
        break;
      case 'delInnerCartItem':
        this.delInnerCartItem();
        break;
      case 'adjInnerCartItemCount':
        this.adjInnerCartItemCount();
        break;
      case 'getEmailOptIn':
        this.onCheckEmailOptIn(sStorageKey);
        break;
      case 'putEmailOptIn':
        this.showOptInToast();
        break;
      default:
        break;
    }
  }

  clearEvent = () => {
    if (this.oEmailOptInLayer) {
      this.oEmailOptInLayer.clearEvent();
    }
    if (this.oSurgeSaleDealLayer) {
      this.oSurgeSaleDealLayer.clearEvent();
    }
  };

  onChangePurchaseOption = async () => {
    const {
      bSkipValidation,
      aKeyList,
      nCurrentDepth, // 0 ~ (MAX - 1)
    } = TMON.oApp.htStorage.purchaseOption;
    const { totalDepth } = TMON.oApp.htStorage.optionInfo;

    // 지금 변경된 depth가 selector의 마지막 depth일 때는 validateAddToInnerCart를 진행한다.
    if (nCurrentDepth === totalDepth - 1) {
      TMON.oApp.setStorage('validateAddToInnerCart', {
        nOptionNo: aKeyList[nCurrentDepth],
        bSkipValidation,
      });
    }
  };

  onBuyNow = () => {
    /* eslint-disable camelcase */
    const { cart_key } = TMON.oApp.htStorage.buyNow;

    if (
      // 성공시 응답값에는 success 키가 아예 존재하지 않는다. 주문 API 의 문제점으로 보이며, 딜상세 입장에서는 개선할 방법이 없기 때문에 아래와 같이 강타입으로 검사하는 방법을 택한다.
      TMON.oApp.htStorage.buyNow.success === false ||
      TMON.oApp.htStorage.buyNow.success === 'false' ||
      !cart_key // 또한 에러 상황에서 카트키도 넘어온다. 따라서 카트키로만 성공 여부를 판단해선 안된다. -_-
    ) {
      if (TMON.oApp.htStorage.buyNow.error_msg) {
        // 에러 상황일 때 에러메시지가 있다면 얼럿을 띄워준다.
        alert(TMON.oApp.htStorage.buyNow.error_msg);
      }
      return;
    }

    const sUrl = `${TMON.htLocal.htURL.www_m_buyDirect}/${cart_key}?from=direct`;

    if (TMON.bLogin) {
      window.location.href = sUrl;
    } else {
      // 로그인이 되어있지 않을 경우 로그인 페이지로 이동
      TMON.oApp.oUtil.login(sUrl, 'message=login_required');
    }
    /* eslint-disable camelcase */
  };

  onBuyGift = () => {
    const returnData = TMON.oApp.htStorage.buyGift;
    if (
      returnData &&
      returnData.httpCode === 200 &&
      typeof returnData.data === 'string' &&
      returnData.data.length !== 0
    ) {
      if ((TMON.oApp.sPlatform === 'MW' || TMON.oApp.sPlatform === 'PW') && !TMON.bLogin) {
        TMON.oApp.oUtil.login(returnData.data);
      } else {
        window.location.href = returnData.data;
      }
    } else {
      // 에러 상황일 때 에러메시지가 있다면 얼럿을 띄워준다.
      const sErrorMsg =
        (typeof returnData.data === 'object' &&
          returnData.data.exceptionMessage) ||
        '일시적인 장애이거나, 1인당 최대 구매수량을 초과한 상품, 매진 및 판매종료된 상품이 있습니다. 상품의 수량을 다시 확인해 주세요.';
      alert(sErrorMsg);
    }
  };

  onOptionList = () => {
    // InnerCart(비었을 때)의 자동 완성이 요구되는 타이밍이 있다.
    if (!TMON.oApp.getStorage('innerCartItems')) {
      // 단일 옵션일 때
      if (this.bOnlyOption && !this.bOptionDeal) {
        TMON.oApp.setStorage('validateAddToInnerCart', {
          nOptionNo: TMON.oApp.htStorage.optionInfo.onlyOptionSrl,
          bSkipValidation: true,
        });
      }
      // optionList를 기다릴 때
      if (
        this.bPendingOptionList &&
        TMON.oApp.htStorage.validateAddToInnerCart
      ) {
        this.validateAddToInnerCart();
      }
    }
  };

  /**
   * 현재 선택된 옵션 갯수의 합이 딜의 최소 구매 수량에 유효한지 확인한다.
   */
  isValidMinCount = (nCount, htOption) => {
    const { minPurchasableQtyPerPerson } = TMON.oApp.getStorage(
      'htStaticData'
    ).htDealInfo;

    // 최소 구매 가능 값 없음
    if (isNaN(minPurchasableQtyPerPerson) || minPurchasableQtyPerPerson < 1)
      return true;

    // 딜 최소 구매수량보다 큰지 확인
    if (!htOption && nCount < minPurchasableQtyPerPerson) {
      alert(
        `해당 상품의 최소 구매 수량은 총 ${minPurchasableQtyPerPerson}개입니다. 구매 수량을 다시 확인해 주세요.`
      );
      return false;
    }

    // 마케팅 딜 및 가능 유무 체크
    if (!this.checkOptInDeal()) {
      return false;
    }

    return true;
  };

  /**
   * 현재 선택된 옵션 갯수의 합이 딜의 1회 최대 구매 수량에 유효한지 확인한다.
   * - 스토어 딜에서는 아직 사용하지 않지만 로컬에서 사용
   */
  isValidMaxOnceCount = nCount => {
    const { maxPurchasableQtyPerPersonAtOnce } = TMON.oApp.getStorage(
      'htStaticData'
    ).htDealInfo;

    // 1회 최대 구매 가능 값 없음
    if (
      isNaN(maxPurchasableQtyPerPersonAtOnce) ||
      maxPurchasableQtyPerPersonAtOnce < 1
    )
      return true;

    // 딜의 1회 최대 구매 가능 갯수와 비교
    if (nCount > maxPurchasableQtyPerPersonAtOnce) {
      alert(
        `1인당 1회 최대 구매 수량은 총 ${maxPurchasableQtyPerPersonAtOnce}개입니다. 구매 수량을 다시 확인해 주세요.`
      );
      return false;
    }

    return true;
  };

  /**
   * 메인딜 기준 : 현재 선택된 옵션 갯수와 이전 구매 내역의 합이 딜의 최대 구매 수량에 유효한지 확인한다.
   */
  isValidMaxCount = nCount => {
    const {
      maxPurchasableQtyPerPerson,
      // dealNo // main deal srl
    } = TMON.oApp.getStorage('htStaticData').htDealInfo;

    let totalBuyCount = 0;

    if (
      TMON.oApp.getStorage('orderCount') &&
      TMON.oApp.getStorage('orderCount').data
    ) {
      totalBuyCount = TMON.oApp.getStorage('orderCount').data.totalBuyCount;
    }

    // 인당 최대 구매 가능 값 없음
    if (isNaN(maxPurchasableQtyPerPerson) || maxPurchasableQtyPerPerson < 1)
      return true;
    // 인당 최대 구매 가능 갯수보다 적은지 확인
    if (
      nCount >
      (TMON.htStaticData.isOneTimeOneBuyDeal ? 1 : maxPurchasableQtyPerPerson)
    ) {
      const text = TMON.htStaticData.isOneTimeOneBuyDeal
        ? '1회 주문 시 수량 1개만 구매 가능합니다.\n옵션 변경을 원하시는 경우, 선택 된 옵션 삭제 후 재 선택 해주세요.'
        : `1인당 구매 가능한 수량은 ${maxPurchasableQtyPerPerson}개입니다. 구매 수량을 확인해주세요.`;
      alert(text);
      return false;
      // 이전 구매 내역 포함해서 초과할 때
    }
    if (
      !isNaN(totalBuyCount) &&
      totalBuyCount > 0 &&
      totalBuyCount + nCount > maxPurchasableQtyPerPerson
    ) {
      alert(
        `현재 구매 가능한 수량은 ${maxPurchasableQtyPerPerson -
          totalBuyCount}개입니다. 구매하신 내역이 없는지 확인해주세요.`
      );
      return false;
    }
    return true;
  };

  isValidMaxOptCount = (nAdj, htOption) => {
    if (!htOption) return true;

    const nCount = htOption.count + nAdj;

    if (htOption.orderDealMax.availableBuyCount === 0) {
      alert(
        '회원님의 구매 가능한 수량은 0개입니다. 구매하신 내역이나 카트를 확인해주세요.'
      );
      return false;
    }
    if (nCount > htOption.orderDealMax.availableBuyCount) {
      alert(
        `옵션의 최대 구매 가능 수량은 ${htOption.orderDealMax.availableBuyCount}개 입니다. 다시 시도해 주시기 바랍니다.`
      );
      return false;
    }

    return true;
  };

  /**
   * 현재 선택된 옵션이 인당 최소 최대 구매 수량에 유효한지 확인한다.
   */
  isValidMaxMinCount = (nAdj = 0, optionNo, bExpMinCount) => {
    const aList = TMON.oApp.getStorage('innerCartItems')
      ? TMON.oApp.getStorage('innerCartItems').aList
      : [];

    let nSum = 0;
    let htOption = null;

    aList.map(item => (nSum += item.count));

    if (optionNo) {
      htOption = aList.find(item => item.optionNo === optionNo);
    }

    // 옵션을 기준으로 최소 최대 구매 수량 validation
    return (
      this.isValidMaxCount(nSum + nAdj) && // 최종 선택된 옵션들의 최대 구매 가능 값
      this.isValidMaxOptCount(nAdj, htOption) && // 특정 옵션의 최대 구매 가능 값
      (bExpMinCount || this.isValidMinCount(nSum + nAdj, htOption)) && // 최소 구매 가능 값 검사해야 할 경우 (최종 선택된 옵션의 최소 구매 값 || 특정 옵션의 최소 구매 가능 값)
      this.isValidMaxOnceCount(nSum + nAdj)
    );
  };
  
  /**
   * 추가 구매 옵션이 선택되어 있을 때 추가 구매 옵션이 아닌 옵션도 포함되어 있는지 확인한다.
   */
  isValidBundleOpt = () => {
    const aList = TMON.oApp.getStorage('innerCartItems')
      ? TMON.oApp.getStorage('innerCartItems').aList
      : [];
    const isBundleOnlyOpt = aList.filter(item => item.isBundleOnly === true);
    if (isBundleOnlyOpt.length >= aList.length) {
      return false;
    }
    return true;
  }

  /**
   * 선택된 옵션 리스트를 API에서 필요한 포맷에 맞춰 편집한다. 매진된 상품은 포함하지 않는다.
   */
  getSelectedOptionInfo = () => {
    const aOptionDealSrl = [];
    const aCount = [];
    const aPrice = [];
    let nTotal = 0;

    if (
      TMON.oApp.htStorage.innerCartItems &&
      TMON.oApp.htStorage.innerCartItems.aList
    ) {
      TMON.oApp.htStorage.innerCartItems.aList.map(item => {
        const { optionNo, count } = item;

        const htDiscountInfos = TMON.oApp.oUtil.getDiscountInfos(item);

        if (!item.orderDealMax.soldOut) {
          // 매진된 상품은 포함하지 않는다.
          aOptionDealSrl.push(optionNo);
          aCount.push(count);

          if (htDiscountInfos && htDiscountInfos.price) {
            aPrice.push(htDiscountInfos.price);
            nTotal += count * htDiscountInfos.price;
          }
        }

        return true;
      });
    }

    return {
      aOptionDealSrl,
      aCount,
      aPrice,
      nTotal,
    };
  };

  async validateAddToCart() {
    if (!this.bEnablePuchaseAreaButton && TMON.view_mode === 'app') {
      TMON.oApp.setStorage(
        'toast',
        '구매가 진행 중입니다. <br /> 잠시만 기다려 주세요.'
      );
      return;
    }

    // PC 에서는 카트담기 버튼이 밖으로 꺼내져 있기 때문에 innerCartItems 에 상품이 없어도 카트담기 액션을 할 수 있다.
    if (
      !TMON.oApp.htStorage.innerCartItems ||
      TMON.oApp.htStorage.innerCartItems.aList.length < 1
    ) {
      alert('상품 옵션 또는 수량을 선택하여 주세요.');
      return;
    }

    // 마케팅 딜 및 가능 유무 체크
    if (!this.checkOptInDeal()) {
      return;
    }

    // 장바구니에 담은 딜이 100개 이상이면 카트 추가 불가 안내 팝업 노출
    if (TMON.htStaticData.cartCount >= 100) {
      const oCartFullLayer = new CartFullLayer();
      oCartFullLayer.open();
      return;
    }

    if (
      TMON.oApp.getStorage('optionList') &&
      TMON.oApp.getStorage('optionList').data.length > 0 &&
      this.isValidMaxMinCount() &&
      !this.isValidCartSurgeSale()
    ) {
      const {
        aOptionDealSrl: aOptionNoForCart,
        aCount: aCountForCart,
        nTotal: nTotalValue,
        aPrice,
      } = this.getSelectedOptionInfo();

      TMON.oApp.setStorage('willAddToCart', {
        sMainDealSrlForCart: TMON.oApp.htStorage.htStaticData.sDealNo,
        aOptionNoForCart,
        aCountForCart,
        nTotalValue,
        aPrice,
      });
    }
  }

  buyNowApp = sType => {
    const { aOptionDealSrl, aCount } = this.getSelectedOptionInfo();

    // 바로구매 앱 카운트 검증
    if (!this.isValidMaxMinCount()) {
      return;
    }

    // 판매 급증으로 인한 취소 가능성 알림 노출
    if (this.isValidBuySurgeSale()) {
      return;
    }

    if (!this.bEnablePuchaseAreaButton) {
      TMON.oApp.setStorage(
        'toast',
        '구매가 진행 중입니다. <br /> 잠시만 기다려 주세요.'
      );
      return;
    }

    this.bEnablePuchaseAreaButton = false;

    if (!this.oEnablePuchaseAreaButtonInterval) {
      this.oEnablePuchaseAreaButtonInterval = setInterval(() => {
        this.bEnablePuchaseAreaButton = true;
      }, 7000);
    }

    let sPayType = '';

    switch (sType) {
      case 'payco':
        sPayType = 'payco';
        break;
      case 'tmonpay':
        sPayType = 'y';
        break;
      default:
        sPayType = 'n';
    }

    try {
      TMON.app.callApp(
        'webview',
        'goBuyDeal',
        TMON.oApp.htStorage.htStaticData.sDealNo.toString(),
        aOptionDealSrl.join(','),
        aCount.join(','),
        '바로구매',
        sPayType,
        'TMON.oDealMain.oCallWeb.afterBuy'
      );
    } catch (e) {
      TMON.oApp.errorHandler({
        error: e,
        componentName: 'PurchaseContainer',
        from: 'buyNowApp',
        actionType: 'alert',
        actionValue: `죄송합니다. 일시적인 오류가 발생했습니다. 문제가 계속되면 고객센터로 연락 부탁드립니다. 에러코드 : ${e}`,
        bLoggingEslog: true,
      });
    }
  };

  validateBuyNow() {
    const {
      // action, add? delete?
      type,
    } = TMON.oApp.getStorage('validateBuyNow');
    // 공유 특가딜 구입시 트레킹코드
    if (TMON.htStaticData.isShareDeal) {
      const tlArea = TMON.oApp.sPlatform === 'PW' ? 'SDPYPC' : 'SMYPC';
      const target = $('[data-type=buyNow]').get(0);
      target.dataset.tlarea = tlArea;
      TMON.sendLog(null, [
        target,
        null,
        {
          'tl:area': tlArea,
        },
      ]);
    }

    if (TMON.oApp.sPlatform === 'MA') {
      // [Tracker] 티몬데이딜 & 구매시 tracking
      if (TMON.htStaticData.bTimeAttackDeal) {
        TMON.oApp.setStorage('sendTracker', 'buy');
      }
      this.buyNowApp(type);
      return;
    }

    const { aOptionDealSrl, aCount } = this.getSelectedOptionInfo();

    const {
      dealInfoContentsLevel,
      isAdultCert,
    } = TMON.oApp.htStorage.htStaticData;

    if (dealInfoContentsLevel === 'BOTTOM' && !isAdultCert) {
      if (!TMON.bLogin) {
        // 로그인이 되어 있지 않다.
        TMON.oApp.oUtil.login();
      } else {
        TMON.oApp.setStorage('openAdultCert', true); // 성인인증 레이어를 띄움
      }
    } else if (this.isValidMaxMinCount() && !this.isValidBuySurgeSale()) {
      // [Tracker] 티몬데이딜 & 구매시 tracking
      if (TMON.htStaticData.bTimeAttackDeal) {
        TMON.oApp.setStorage('sendTracker', 'buy');
      }

      TMON.oApp.oApi.fetchApi('buyNow', {
        aOptionDealSrl,
        aCount,
      });
    }
  }

  isValidSurgeSale = () => {
    // 판매 급증으로 인한 취소 가능성 알림 노출 여부
    if (TMON.htStaticData.isSurgeSaleDeal) {
      if (!this.oSurgeSaleDealLayer) {
        this.oSurgeSaleDealLayer = new SurgeSaleDealLayer();
      }
      return true;
    }
    return false;
  };

  isValidBuySurgeSale = () => {
    // 판매 급증으로 인한 취소 가능성 알림 노출
    if (this.isValidSurgeSale()) {
      if (!this.oSurgeSaleDealLayer.isCheckedBuy()) {
        this.oSurgeSaleDealLayer.open('validateBuyNow');
        this.oSurgeSaleDealLayer.isCheckBuy = true;
        return true;
      }
    }

    return false;
  };

  isValidCartSurgeSale = () => {
    // 판매 급증으로 인한 취소 가능성 알림 노출
    if (this.isValidSurgeSale()) {
      if (!this.oSurgeSaleDealLayer.isCheckedCart()) {
        this.oSurgeSaleDealLayer.open('validateAddToCart');
        this.oSurgeSaleDealLayer.isCheckCart = true;
        return true;
      }
    }

    return false;
  };

  isValidGiftSurgeSale = () => {
    // 판매 급증으로 인한 취소 가능성 알림 노출
    if (this.isValidSurgeSale()) {
      if (!this.oSurgeSaleDealLayer.isCheckedGift()) {
        this.oSurgeSaleDealLayer.open('validateBuyGift');
        this.oSurgeSaleDealLayer.isCheckGift = true;
        return true;
      }
    }

    return false;
  };

  buyGiftApp = () => {
    const { aOptionDealSrl, aCount } = this.getSelectedOptionInfo();

    // 선물하기 카운트 검증
    if (!this.isValidMaxMinCount()) {
      return;
    }

    // 판매 급증으로 인한 취소 가능성 알림 노출
    if (this.isValidGiftSurgeSale()) {
      return;
    }

    if (!this.bEnablePuchaseAreaButton) {
      // TODO
      TMON.oApp.setStorage(
        'toast',
        '선물하기가 진행 중입니다. <br /> 잠시만 기다려 주세요.'
      );
      return;
    }

    this.bEnablePuchaseAreaButton = false;

    if (!this.oEnablePuchaseAreaButtonInterval) {
      this.oEnablePuchaseAreaButtonInterval = setInterval(() => {
        this.bEnablePuchaseAreaButton = true;
      }, 7000);
    }

    try {
      TMON.app.callApp(
        'webview',
        'goGift',
        TMON.oApp.htStorage.htStaticData.sDealNo.toString(),
        aOptionDealSrl.join(','),
        aCount.join(','),
        '선물하기',
        'n',
        'TMON.oDealMain.oCallWeb.afterBuy'
      );
    } catch (e) {
      TMON.oApp.errorHandler({
        error: e,
        componentName: 'PurchaseContainer',
        from: 'buyGiftApp',
        actionType: 'alert',
        actionValue: `죄송합니다. 일시적인 오류가 발생했습니다. 문제가 계속되면 고객센터로 연락 부탁드립니다. 에러코드 : ${e}`,
        bLoggingEslog: true,
      });
    }
  };

  validateBuyGift() {
    if (TMON.oApp.sPlatform === 'MA') {
      // TODO
      // [Tracker] 티몬데이딜 & 구매시 tracking
      if (TMON.htStaticData.bTimeAttackDeal) {
        TMON.oApp.setStorage('sendTracker', 'buy');
      }

      this.buyGiftApp();
      return;
    }

    const { aOptionDealSrl, aCount } = this.getSelectedOptionInfo();

    const {
      dealInfoContentsLevel,
      isAdultCert,
      sDealNo,
    } = TMON.oApp.htStorage.htStaticData;

    if (dealInfoContentsLevel === 'BOTTOM' && !isAdultCert) {
      if (!TMON.bLogin) {
        // 로그인이 되어 있지 않다.
        TMON.oApp.oUtil.login();
      } else {
        TMON.oApp.setStorage('openAdultCert', true); // 성인인증 레이어를 띄움
      }
    } else if (this.isValidMaxMinCount() && !this.isValidGiftSurgeSale()) {
      // TODO
      // [Tracker] 티몬데이딜 & 구매시 tracking
      if (TMON.htStaticData.bTimeAttackDeal) {
        TMON.oApp.setStorage('sendTracker', 'buy');
      }

      const basketItemList = [];

      for (let i = 0; i < aOptionDealSrl.length; i += 1) {
        basketItemList.push({
          mainDealSrl: sDealNo,
          dealSrl: aOptionDealSrl[i],
          count: aCount[i],
        });
      }

      TMON.oApp.oApi.fetchApi('buyGift', {
        data: JSON.stringify({
          present: true,
          basketItemList,
        }),
      });
    }
  }

  validateAddToInnerCart() {
    const { nOptionNo, bSkipValidation } = TMON.oApp.getStorage(
      'validateAddToInnerCart'
    );

    this.bPendingOptionList = false;
    if (
      !TMON.oApp.getStorage('optionList') ||
      !TMON.oApp.getStorage('optionList').data.length
    ) {
      // optionList 도착 이후 다시 시도
      this.bPendingOptionList = true;
      return;
    }

    const htOption = TMON.oApp.getStorage('optionList').htRefined[nOptionNo];
    const innerCartItem = 
      TMON.oApp.getStorage('innerCartItems') && 
      TMON.oApp.getStorage('innerCartItems').aList &&
      TMON.oApp.getStorage('innerCartItems').aList.find((el) => el.optionNo === Number(nOptionNo));
    const bOverAbleBuyCount =
      innerCartItem &&
      innerCartItem.count &&
      innerCartItem.orderDealMax &&
      innerCartItem.orderDealMax.availableBuyCount &&
      innerCartItem.orderDealMax.availableBuyCount <= innerCartItem.count;

    if (bSkipValidation) {
      this.addInnerCartItem(nOptionNo);
    } else if (
      htOption.orderDealMax &&
      !htOption.orderDealMax.soldOut &&
      this.isValidMaxMinCount(1, nOptionNo, true) &&
      !innerCartItem || !bOverAbleBuyCount
    ) {
      this.addInnerCartItem(nOptionNo);
    } else if (bOverAbleBuyCount) {
      alert(`현재 구매 가능한 수량은 ${innerCartItem.orderDealMax.availableBuyCount}개입니다.`)
    }
  }

  addInnerCartItem(optionNo) {
    const htItem = TMON.oApp.getStorage('optionList').htRefined[optionNo];

    if (!htItem) {
      console.warn(`${optionNo}가 존재하지 않습니다.`);
      return;
    }

    let aItems = [];
    let nTargetIndex = 0;
    let sAction = 'add';

    if (TMON.oApp.htStorage.innerCartItems) {
      aItems = TMON.oApp.htStorage.innerCartItems.aList.slice();
      nTargetIndex = aItems.findIndex(item => item.optionNo === +optionNo);

      // 중복 아이템 여부 검증
      if (nTargetIndex < 0) {
        aItems.push(
          Object.assign({}, htItem, {
            count: 1,
          })
        );

        nTargetIndex = aItems.length - 1;
      } else {
        sAction = 'updateCount';
        aItems[nTargetIndex].count += 1;
      }
    } else {
      aItems = [
        Object.assign({}, htItem, {
          count: 1,
        }),
      ];
    }

    TMON.oApp.setStorage('innerCartItems', {
      sAction,
      nTargetOptionNo: optionNo,
      htTargetItem: aItems[nTargetIndex],
      aList: aItems,
    });
  }

  delInnerCartItem() {
    const {
      // action, add? delete?
      optionNo,
    } = TMON.oApp.htStorage.delInnerCartItem;

    const aItems = TMON.oApp.htStorage.innerCartItems.aList.slice();
    const aOption =
      typeof optionNo.split === 'function' ? optionNo.split(',') : [optionNo];
    const nLen = aOption.length;

    for (let i = 0; i < nLen; i += 1) {
      aItems.splice(
        aItems.findIndex(item => item.optionNo === aOption[i]),
        1
      );
    }

    TMON.oApp.setStorage('innerCartItems', {
      nTargetOptionNo: optionNo,
      sAction: 'delete',
      aList: aItems,
    });
  }

  adjInnerCartItemCount() {
    const { optionNo, adj } = TMON.oApp.htStorage.adjInnerCartItemCount;

    // TODO: sAction UpdateCount 하나로 변경
    // 여러 개의 아이템을 한번에 변경해야 할 때
    if (
      typeof optionNo.split === 'function' &&
      optionNo.split(',').length > 0
    ) {
      const aItems = TMON.oApp.htStorage.innerCartItems.aList.map(htItem => {
        const htTarget = $.extend({}, htItem);

        htTarget.count += adj;

        return htTarget;
      });

      TMON.oApp.setStorage('innerCartItems', {
        sAction: 'join',
        aList: aItems,
      });

      // 하나의 아이템만 업데이트 할 때
    } else {
      const aItems = TMON.oApp.htStorage.innerCartItems.aList.slice();
      const nTargetIndex = aItems.findIndex(item => item.optionNo === optionNo);

      aItems[nTargetIndex].count += adj;

      if (nTargetIndex > -1) {
        TMON.oApp.setStorage('innerCartItems', {
          nTargetOptionNo: optionNo,
          htTargetItem: aItems[nTargetIndex],
          sAction: 'updateCount',
          aList: aItems,
        });
      }
    }
  }

  onCheckEmailOptIn = sStorageKey => {
    const { agreeRecvMail, hasMemberEmail } = TMON.oApp.getStorage(
      sStorageKey
    ).data;
    if (agreeRecvMail && hasMemberEmail) {
      alert(
        '이 상품은 티몬 광고메일을 통해 구매 가능한 전용 상품입니다.\n(받으신 혜택 메일을 클릭하고 방문해 주세요.)'
      );
    } else {
      this.oEmailOptInLayer.setHasMemberEmail(hasMemberEmail);
      this.oEmailOptInLayer.open();
    }
  };

  showOptInToast = () => {
    const date = new Date();
    const msg = `<span class="toast_common_popup_date">${date.getFullYear()}.${date.getMonth() +
      1}.${date.getDate()}</span><p class="toast_common_popup_text">이벤트 혜택메일 수신동의가<br>완료되었습니다.</p>`;
    TMON.oApp.oCommonToast.showToast(msg);
  };

  // 마케팅 딜 체크
  checkOptInDeal = () => {
    // 마케팅 딜 인지 확인 및 구매가능 여부
    const { isOptInDeal, isOptInDealCert } = TMON.htStaticData;

    if (isOptInDeal) {
      // android일 경우 4.9.9 버전은 지원 안함
      /* eslint-disable no-underscore-dangle */
      if (TMON.sDevice === 'MA' && !TMON.app._isValidAppVersion('5.0.0')) {
        alert(
          '마케팅 수신동의 전용 딜은 새로운 버전에서만 이용하실 수 있습니다.\nAPP 업데이트 후 이용하시기 바랍니다.'
        );
        return false;
      }
      if (!isOptInDealCert) {
        if (!TMON.bLogin) {
          // 로그인이 되어 있지 않다.
          TMON.oApp.oUtil.login();
        }

        if (!this.oEmailOptInLayer) {
          this.oEmailOptInLayer = new EmailOptInLayer();
        }

        TMON.oApp.oApi.fetchApi('getEmailOptIn');

        return false;
      }
    }
    return true;
  };
}
